import { RollbackOutlined, SaveOutlined } from '@ant-design/icons'
import { Button, Form, InputNumber, TimePicker } from 'antd'
import { FormInstance } from 'antd/lib/form'
import React, { RefObject } from 'react'

import { START_TIME_FORMAT } from '../../constants/flights'

export type StartTimeFormData = {
  startTime: Date
  applyFrom: number
  interval: number
}

type StartTimeFormProps = {
  defaultInterval?: number
  numberOfFlights: number
  onSubmit(startTime: Date, interval: number, applyFrom: number): void
  onCancel(): void
}

class StartTimeForm extends React.Component<StartTimeFormProps> {
  formRef: RefObject<FormInstance<any>> = React.createRef()

  handleSubmit = (values) => {
    const { onSubmit } = this.props
    onSubmit(values.startTime.toDate(), values.interval, values.applyFrom)
  }

  handleFailure = ({ errorFields }) => {
    this.formRef?.current?.scrollToField(errorFields[0].name)
    /* TODO display somewhere */
    // tslint:disable-next-line:no-console
    console.log('Error during validation', errorFields)
  }

  render() {
    const { defaultInterval, numberOfFlights, onCancel } = this.props

    return (
      <Form
        ref={this.formRef}
        onFinish={this.handleSubmit}
        onFinishFailed={this.handleFailure}
        initialValues={{
          interval: defaultInterval,
          applyFrom: 1,
        }}>
        <Form.Item
          label="Start Time"
          hasFeedback
          name="startTime"
          rules={[{ required: true, message: 'Please input start time!' }]}>
          <TimePicker format={START_TIME_FORMAT} />
        </Form.Item>
        <Form.Item
          label="Interval"
          hasFeedback
          name="interval"
          rules={[{ required: true, message: 'Please input interval!' }]}>
          <InputNumber min={1} />
        </Form.Item>
        <Form.Item
          label="Apply From"
          hasFeedback
          name="applyFrom"
          rules={[
            {
              required: true,
              message: 'Please input number of flight to apply the start time from!',
            },
          ]}>
          <InputNumber min={1} max={numberOfFlights} />
        </Form.Item>
        <Button.Group>
          <Button danger onClick={onCancel} icon={<RollbackOutlined />}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
            Submit
          </Button>
        </Button.Group>
      </Form>
    )
  }
}

export default StartTimeForm



// WEBPACK FOOTER //
// ./src/components/flights/StartTimeForm.tsx